import React from "react";
import { $t } from '@/modules/i18n';

const twoColumns = ({ message = [] }) => (
  <div className="two-columns">
  {
    message.map(item => (
      <div className="item" key={item.question}>
        <div className="question">{$t(item.question)}</div>
        <ul className="answers">
        {
          item.answers.map(answers => <li className="text" key={answers}><span  dangerouslySetInnerHTML={{ __html: $t(answers) }}></span></li>)
        }
        </ul>
      </div>
    ))
  }
  </div>
)

export default twoColumns;
